import { createBrowserRouter, Navigate } from 'react-router-dom';

import Default from 'pages/Default';
import DeviceList from 'pages/DeviceList';
import NetErrorPage from 'pages/NetErrorPage';
import StatusBoard from 'pages/StatusBoard';

import SignIn from '../pages/SignIn';
import { retryLazy } from '../util/lazyUtil';
import AuthGuard from './AuthGuard';
import ProtectedRoute from './ProtectedRoute';

const Mypage = retryLazy(() => import('pages/Mypage'));
const AuthConfirmPassword = retryLazy(
  () => import('pages/AuthConfirmPassword'),
  'AuthConfirmPassword',
);
const LotoConclusion = retryLazy(
  () => import('pages/loto-status/LotoConclusion'),
  'LotoConclusion',
);
const OldLoto = retryLazy(() => import('pages/loto-status/OldLoto'), 'OldLoto');
const LotoCommunication = retryLazy(
  () => import('pages/loto-status/LotoCommunication'),
  'LotoCommunication',
);
const LotoActionLog = retryLazy(
  () => import('pages/loto-status/LotoActionLog'),
  'LotoActionLog',
);
const LotoSetting = retryLazy(
  () => import('pages/loto-management/LotoSetting'),
  'LotoSetting',
);
const LotoLog = retryLazy(
  () => import('pages/loto-management/LotoLog'),
  'LotoLog',
);
const LotoPermission = retryLazy(
  () => import('pages/loto-management/LotoPermission'),
  'LotoPermission',
);
const LotoSelfPermission = retryLazy(
  () => import('pages/loto-management/LotoSelfPermission'),
  'LotoSelfPermission',
);
const LotoPermissionLog = retryLazy(
  () => import('pages/loto-management/LotoPermissionLog'),
  'LotoPermissionLog',
);
const LotoPermissionTransfer = retryLazy(
  () => import('pages/loto-management/LotoPermissionTransfer'),
  'LotoPermissionTransfer',
);
const LotoBox = retryLazy(
  () => import('pages/loto-management/LotoBox'),
  'LotoBox',
);

const UserList = retryLazy(() => import('pages/UserList'), 'UserList');
const LockerList = retryLazy(() => import('pages/LockerList'), 'LockerList');
const LockAuth = retryLazy(() => import('pages/LockAuth'), 'LockAuth');

const FactoryPosition = retryLazy(
  () => import('pages/equip-position/FactoryPosition'),
  'FactoryPosition',
);
const AreaPosition = retryLazy(
  () => import('pages/equip-position/AreaPosition'),
  'AreaPosition',
);
const ZonePosition = retryLazy(
  () => import('pages/equip-position/ZonePosition'),
  'ZonePosition',
);
const EquipmentPosition = retryLazy(
  () => import('pages/equip-position/EquipmentPosition'),
  'EquipmentPosition',
);
const ZonePopup = retryLazy(() => import('pages/ZonePopup'), 'ZonePopup');
const ShiftWorkSetting = retryLazy(
  () => import('pages/ShiftWorkSetting'),
  'ShiftWorkSetting',
);

const routes = createBrowserRouter([
  {
    path: 'sign-in',
    element: <SignIn />,
  },
  // {
  //   path: '/error',
  //   element: <ErrorPage />,
  // },
  {
    path: '/net-error',
    element: <NetErrorPage />,
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Default />
      </AuthGuard>
    ),

    children: [
      { path: '/home/status-board', element: <StatusBoard /> },
      {
        path: '/loto-status/conclusion',
        element: <LotoConclusion />,
      },
      {
        path: '/loto-status/longTerm',
        element: <OldLoto />,
      },
      {
        path: '/loto-status/communication',
        element: <LotoCommunication />,
      },
      {
        path: '/loto-status/action',
        element: <LotoActionLog />,
      },
      {
        path: '/loto-management/setting',
        element: <LotoSetting />,
      },
      {
        path: '/loto-management/box',
        element: <LotoBox />,
      },
      {
        path: '/loto-management/log',
        element: <LotoLog />,
      },
      {
        path: '/loto-management/permission',
        element: <LotoPermission />,
      },
      {
        path: '/loto-management/self-permission/*',
        element: <LotoSelfPermission />,
      },
      {
        path: '/loto-management/permission-log',
        element: <LotoPermissionLog />,
      },
      {
        path: '/loto-management/permission-transfer',
        element: <LotoPermissionTransfer />,
      },
      { path: '/devices/device', element: <DeviceList /> },
      { path: '/devices/factory-position', element: <FactoryPosition /> },
      { path: '/devices/area-position', element: <AreaPosition /> },
      { path: '/devices/zone-position', element: <ZonePosition /> },
      { path: '/devices/equipment-position', element: <EquipmentPosition /> },
      { path: '/lockers/locker', element: <LockerList /> },
      {
        path: '/admin/user',
        element: <UserList />,
      },
      {
        path: '/admin/lock-permission',
        element: <LockAuth />,
      },
      // {
      //   path: '/admin/shift',
      //   element: <ShiftWorkSetting />,
      // },
      { path: '/auth-confirm', element: <AuthConfirmPassword /> },
      {
        path: '/mypage',
        element: (
          <ProtectedRoute>
            <Mypage />
          </ProtectedRoute>
        ),
      },
      { path: '/auth-confirm', element: <AuthConfirmPassword /> },
      { path: '/*', element: <Navigate to={'/home/status-board'} replace /> },
    ],
  },
  { path: '/popup/zone-map/:id', element: <ZonePopup /> },
]);

export default routes;
